import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
//import { parseRawData } from '../../parsers';
import _ from 'lodash';
import { getAdditionalKpis } from 'gqlQueries/promoRecommendation';

const errorMessage: string = 'Something went wrong!';

function useFetchAdditionalKpis({ onCompleted }: { onCompleted: Function }) {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<null | string>(null);

    const [
        fetchAdditionalKpiData,
        { data: additionalKpiData, loading: additionalKpiDataLoading, error: additionalKpiDataError },
    ] = useLazyQuery(getAdditionalKpis, {
        onCompleted: onFetchComplete,
        onError: onFetchError,
    });

    //called when fetching is complete
    function onFetchComplete(payload: any) {
        try {
            onCompleted(payload);
        } catch (error) {
            console.error(errorMessage, error);
            onFetchError(error);
        } finally {
            setLoading(false);
        }
    }

    //called when API throws an error
    function onFetchError(error: any = errorMessage) {
        //sending empty data to error to avoid null data being sent
        setLoading(false);
        setError(error);
    }

    return {
        loading,
        error,
        setLoading,

        fetchAdditionalKpiData: (variables: any) => {
            setError(null);
            setLoading(true);
            fetchAdditionalKpiData(variables);
        },
    };
}

export { useFetchAdditionalKpis };
